import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  Button,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Routes as AppRoutes } from '../../../routes';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';

const InvitationDeclinedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box mt={8}>
        <Card elevation={3}>
          <CardContent sx={{ textAlign: 'center', p: 4 }}>
            <InfoIcon sx={{ fontSize: 60, color: 'info.main', mb: 2 }} />

            <Typography variant="h5" gutterBottom>
              Invitation Declined
            </Typography>

            <Alert severity="info" sx={{ mt: 2, mb: 3, textAlign: 'left' }}>
              You have chosen not to share your information with this
              organisation.
            </Alert>

            <Typography variant="body1" sx={{ mb: 4 }} color="text.secondary">
              The invitation remains valid if you change your mind. You can use
              the invitation link again to accept the invitation and share your
              information.
            </Typography>

            <Typography variant="body2" sx={{ mb: 4 }} color="text.secondary">
              If you have any concerns about data sharing, please contact your
              administrator for more information.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate(AppRoutes.root)}
              data-testid="go-to-login-button"
            >
              Go to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default InvitationDeclinedPage;
